import VectorProps from "./VectorProps";

export default function InfoIcon(props: VectorProps) {
  const { className = "", width } = props;

  return (
    <svg
      className={className}
      width={width}
      height={width}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0.799805C11.9764 0.799805 15.2002 4.02355 15.2002 8C15.2002 11.9764 11.9764 15.2002 8 15.2002C4.02355 15.2002 0.799805 11.9764 0.799805 8C0.799805 4.02355 4.02355 0.799805 8 0.799805Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.93954 5.67032C4.8874 5.61688 4.85963 5.54428 4.86279 5.46969C4.97136 3.5314 6.55765 2.85712 8.00565 2.85712C9.60222 2.85712 11.0605 3.6914 11.0605 5.41826C11.0605 6.6514 10.3348 7.23883 9.63879 7.76797C8.79651 8.40683 8.48451 8.64569 8.48451 9.46626V9.58626C8.48451 9.74405 8.35659 9.87197 8.19879 9.87197H7.27193C7.11591 9.87199 6.98872 9.74684 6.98622 9.59083L6.98279 9.34283C6.93936 8.2834 7.54851 7.63083 8.31765 7.07197C8.99308 6.56455 9.42051 6.23083 9.42051 5.50512C9.42051 4.56226 8.70279 4.17026 7.91879 4.17026C7.00222 4.17026 6.48793 4.71655 6.38508 5.46626C6.36451 5.62283 6.23879 5.75197 6.08108 5.75197H5.13822C5.06357 5.7533 4.99168 5.72375 4.93954 5.67032ZM7.79651 13.1154C7.12793 13.1154 6.64222 12.6651 6.64222 12.056C6.64222 11.4251 7.12793 10.9817 7.79536 10.9817C8.49136 10.9817 8.97136 11.4251 8.97136 12.056C8.97136 12.6651 8.49251 13.1154 7.79651 13.1154Z"
        fill="currentColor"
      />
    </svg>
  );
}
